export const mkHcRequestError = "mk-hc-request-error";
